import { render, staticRenderFns } from "./account-preview.vue?vue&type=template&id=c622303a"
import script from "./account-preview.vue?vue&type=script&lang=ts"
export * from "./account-preview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports